import { render, staticRenderFns } from "./MonthlyRankingView.vue?vue&type=template&id=c8cf7ca8&"
import script from "./MonthlyRankingView.vue?vue&type=script&lang=js&"
export * from "./MonthlyRankingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports